"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CustomerInfo;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// All enterprise related data
var CustomerInfo = (_CustomerInfo = {
  // General -----------------------------------------------------------------------------------------
  welcome: {
    nl: "Welkom",
    fr: "Bienvenue",
    en: "Welcome"
  },
  search_and_select: {
    nl: "Zoek en selecteer jouw vestiging",
    fr: "Cherchez et sélectionnez votre établissement",
    en: "Search and select your establishment"
  },
  dear: {
    nl: "Beste",
    fr: "Cher",
    en: "Dear"
  },
  ci_yes: {
    nl: "Ja",
    fr: "Oui",
    en: "Yes"
  },
  ci_no: {
    nl: "Nee",
    fr: "Non",
    en: "No"
  },
  next: {
    nl: "Volgende",
    fr: "Suivant",
    en: "Next"
  },
  previous: {
    nl: "Vorige",
    fr: "Précédent",
    en: "Previous"
  },
  ci_close: {
    nl: "Afsluiten",
    fr: "Fermer",
    en: "Close"
  },
  ready_to_collaborate: {
    nl: "Klaar om samen te werken aan jouw",
    fr: "Vous êtes prêt à colaborer ensemble à votre",
    en: "Ready to collaborate on your"
  },
  local_online_visibility: {
    nl: "lokale online visibiliteit?",
    fr: "visibilité locale en ligne ?",
    en: "local online visibility?"
  },
  // Login -----------------------------------------------------------------------------------------
  together_we_work: {
    nl: 'Samen werken we aan een “STERK” verhaal ',
    fr: 'Ensemble, nous travaillons sur une histoire "FORTE"',
    en: 'Together we work on a "STRONG" story '
  },
  discover_the_added_value: {
    nl: "Ontdek de meerwaarde voor jouw onderneming op:",
    fr: "Découvrez la valeur ajoutée pour votre entreprise sur :",
    en: "Discover the added value for your business at:"
  },
  visit_our_site: {
    nl: "Bezoek website",
    fr: "Visitez notre site",
    en: "Visit our site"
  },
  discover_more: {
    nl: "Ontdek meer",
    fr: "Découvrir plus",
    en: "Discover more "
  },
  ci_address: {
    nl: "Adres",
    fr: "Adresse",
    en: "Address"
  },
  is_required_by_law: {
    nl: "(is wettelijk verplicht)",
    fr: "(requise par la loi)",
    en: "(is required by law)"
  },
  tel_mob: {
    nl: "Telefoon of mobiel",
    fr: "Téléphone ou mobile",
    en: "Telephone or mobile"
  },
  number_required_by_law: {
    nl: "(1 nr. is wettelijk verplicht)",
    fr: "(1 est requis par la loi)",
    en: "(1 is required by law) "
  },
  not_Required: {
    nl: "(niet verplicht)",
    fr: "(non requis)",
    en: "(not required)"
  },
  ci_email_login: {
    nl: "E-mail adres",
    fr: "Adresse e-mail",
    en: "E-mail address"
  },
  legally_required: {
    nl: "(is wettelijk verplicht)",
    fr: "(légalement obligatoire)",
    en: "(legally required)"
  },
  ci_main_activity: {
    nl: "Je hoofdactiviteit",
    fr: "Votre activité principale",
    en: "Your main activity"
  },
  in_cbe: {
    nl: "(in KBO):",
    fr: "(en BCE) :",
    en: "(in CBE):"
  },
  ci_customized_activity: {
    nl: "Je aangepaste activiteit via onze diensten",
    fr: "Votre activité sur mesure grâce à nos services",
    en: "Your customized activity through our services"
  },
  sign_up_and_fill_in: {
    nl: "Meld je aan en vul eventuele extra nuttige info aan zodat jouw doelgroep je nog beter kan vinden! Je verdient hiermee € 100!",
    fr: "Inscrivez-vous et remplissez toute information supplémentaire utile pour que votre groupe cible puisse encore mieux vous trouver ! Vous gagnez 100 € avec ça !",
    en: "Sign up and fill in any additional useful information so that your target group can find you even better! You earn € 100 with this!"
  },
  here_you_can_log_in_with: {
    nl: "Hier kan je aanmelden met jouw persoonlijk aangemaakt account.",
    fr: "Ici, vous pouvez vous connecter avec votre compte personnel.",
    en: "Here you can log in with your personally created account."
  },
  register_with_personal_otp: {
    nl: "Registreer hier met jouw persoonlijk OTP",
    fr: "Enregistrez-vous ici avec votre OTP personnel",
    en: "Register here with your personal OTP"
  },
  your_enterprise_number: {
    nl: "Jouw ondernemingsnummer",
    fr: "Votre numéro d'entreprise",
    en: "Your enterprise number"
  },
  your_establishment_number: {
    nl: "Jouw vestigingsnummer",
    fr: "Votre numéro d'etablissement",
    en: "Your establishment number"
  },
  otp: {
    nl: "One Time Password",
    fr: "Mot de passe à usage unique",
    en: "One Time Password"
  },
  dont_have_otp_yet: {
    nl: "Ik heb nog geen OTP",
    fr: "Je n'ai pas encore d'OTP ",
    en: "I don't have an OTP yet"
  },
  password: {
    nl: "Wachtwoord",
    fr: "Mot de passe",
    en: "Password"
  },
  forgot_password: {
    nl: "Wachtwoord vergeten?",
    fr: "Mot de passe oublié ?",
    en: "Forgot password?"
  },
  reset_password: {
    nl: "Wachtwoord resetten",
    fr: "Reset mot de passe",
    en: "Reset password"
  },
  ok_ready: {
    nl: "OK, IK BEN KLAAR",
    fr: "OK, JE SUIS PRÊT ",
    en: "OK, I'M READY "
  },
  i_already_have_account: {
    nl: "Ik heb al een account",
    fr: "J'ai déjà un compte",
    en: "I already have an account"
  },
  i_dont_have_account: {
    nl: "Ik heb nog geen account",
    fr: "Je n'ai pas de compte",
    en: "I don't have an account"
  },
  ci_create_an_account: {
    nl: "Maak een account aan",
    fr: "Créer un compte",
    en: "Create an account"
  },
  ci_create_account: {
    nl: "Account aanmaken",
    fr: "Créer un compte",
    en: "Create account"
  },
  // 01 Welcome -----------------------------------------------------------------------------------------
  welcome_to_local: {
    nl: "Welkom bij 100% Lokaal",
    fr: "100% Locale, soyez les bienvenue",
    en: "Welcome to 100% Local"
  },
  thank_you_for_participating: {
    nl: "Dank je... om mee te werken aan het beheren en optimaliseren van de gegevens van jouw onderneming!",
    fr: "Merci... de participer à la gestion et à l'optimisation des données de votre entreprise !",
    en: "Thank you... for participating in managing and optimizing your company's data !"
  },
  we_help_as_much: {
    nl: "Wij helpen je zoveel mogelijk!",
    fr: "Nous vous aidons au maximum !",
    en: "We help you as much as possible!"
  },
  this_additional_info: {
    nl: "Deze bijkomende informatie zal nuttig zijn voor elke bezoeker die jouw onderneming heeft gevonden.",
    fr: "Ces informations supplémentaires seront utiles à tout visiteur ayant trouvé votre entreprise.",
    en: "This additional information will be useful to any visitor who has found your business."
  },
  my_company_active: {
    nl: "MIJN ONDERNEMING IS ACTIEF?",
    fr: "MON ENTREPRISE EST ACTIVE ?",
    en: "MY COMPANY IS ACTIVE?"
  },
  now_we_can_continue: {
    nl: "Nu kunnen we verder!",
    fr: "Maintenant, nous pouvons continuer !",
    en: "Now we can continue!"
  },
  your_company_deactivated: {
    nl: "Jouw onderneming wordt gedeactiveerd :)",
    fr: "Votre entreprise sera désactivée :)",
    en: "Your company will be deactivated :)"
  },
  i_accept_GDPR: {
    nl: "Ik aanvaard de verwerking van mijn gegevens volgens de GDPR/AVG.",
    fr: "J'accepte le traitement de mes données conformément au RGPD.",
    en: "I accept the processing of my data according to the GDPR."
  },
  last_accepted_on: {
    nl: "Laatst aanvaard op",
    fr: "Dernière acceptation le",
    en: "Last accepted on"
  },
  i_accept_the: {
    nl: "Ik aanvaard de",
    fr: "J'accepte les",
    en: "I accept the"
  },
  general_terms_and_conditions: {
    nl: "algemene voorwaarden",
    fr: "conditions générales",
    en: "general terms and conditions"
  },
  i_accept_my_municipality: {
    nl: "Ik aanvaard dat mijn gegevens - in combinatie met 100procentlokaal - gedeeld worden met mijn stad of gemeente.",
    fr: "J'accepte que mes données - combinées avec 100pourcentlocal - soient partagées avec ma ville ou ma commune.",
    en: "I accept that my data - combined with 100percentlocal - will be shared with my city or municipality."
  },
  city_support_good_idea: {
    nl: "Vind je de ondersteuning van dit initiatief door jouw stad of gemeente een goed idee?",
    fr: "Pensez-vous que le soutien de votre ville ou municipalité à cette initiative est une bonne idée ?",
    en: "Do you think your city or municipality's support for this initiative is a good idea?"
  },
  would_you_find_city_support_good_idea: {
    nl: "Zou jij de ondersteuning van dit initiatief door jouw stad of gemeente een goed idee vinden?",
    fr: "Considéreriez-vous que soutenir cette initiative par votre ville ou municipalité serait une bonne idée ?",
    en: "Would you consider supporting this initiative by your city or municipality a good idea?"
  },
  please_choose_an_option: {
    nl: "Gelieve een optie te kiezen!",
    fr: "Veuillez choisir une option !",
    en: "Please choose an option!"
  },
  yes_i_appreciate_support_city: {
    nl: "Ja! Ik waardeer de ondersteuning van dit initiatief door mijn stad of gemeente",
    fr: "Oui! J'apprécie le soutien de ma ville ou municipalité pour cette initiative",
    en: "Yes! I appreciate the support of my city or municipality for this initiative"
  },
  yes_i_would_appreciate_support_city: {
    nl: "Ja! Ik zou de ondersteuning van dit initiatief door mijn stad of gemeente een schitterend idee vinden!",
    fr: "Oui ! J'aimerais le soutien de ma ville ou municipalité pour cette initiative!",
    en: "Yes! I would love the support of my city or municipality for this initiative!"
  },
  no_opinion_about_project: {
    nl: "Ik heb geen mening over dit project",
    fr: "Je n'ai pas d'avis sur ce projet",
    en: "I have no opinion about this project"
  },
  contest: {
    nl: "WEDSTRIJD!",
    fr: "CONCOURS !",
    en: "CONTEST!"
  },
  you_are_participating_too_right: {
    nl: "Jij doet toch ook mee?",
    fr: "Participez-vous aussi ?",
    en: "You're participating too, right?"
  },
  fantastic: {
    nl: "Fantastisch!",
    fr: "Fantastique !",
    en: "Fantastic!"
  },
  you_do_not_know_what_missing: {
    nl: "Je weet niet wat je mist :)",
    fr: "Vous ne savez pas ce que vous manquez :)",
    en: "You do not know what you are missing :)"
  },
  for_the: {
    nl: "Voor de",
    fr: "Pour la",
    en: "For the"
  },
  businesspage_100procentlocal: {
    nl: "Business Page in 100%Lokaal",
    fr: "Page Entreprise en 100% Local",
    en: "Business Page in 100%Local"
  },
  businesspage_100procentlocal_part_2: {
    nl: "betaalt de ondernemer € 100/jaar. Dit is het éénmalig voordeel dat je verkrijgt wanneer je alle gegevens voor jouw onderneming aanvult!",
    fr: "l'entrepreneur paie 100 €/an. C'est l'avantage unique que vous recevez lorsque vous remplissez toutes les données pour votre entreprise !",
    en: "the entrepreneur pays € 100/year. This is the one-time benefit that you receive when you complete all the data for your company!"
  },
  businesspage_100procentlocal_part_3: {
    nl: "Bovendien doet iedere ondernemer die deelneemt ook automatisch mee met de grote wedstrijd. Elke 100ste ondernemer wint een jaarabonnement voor een compleet dienstenpakket ter waarde van € 1600.",
    fr: "De plus, chaque entrepreneur qui participe participe automatiquement au grand concours. Chaque 100e entrepreneur gagne un abonnement annuel pour un ensemble complet de services d'une valeur de 1600 €.",
    en: "In addition, every entrepreneur who participates automatically participates in the big competition. Every 100th entrepreneur wins an annual subscription for a complete service package worth € 1600."
  },
  attention: {
    nl: "OPGELET!",
    fr: "ATTENTION !",
    en: "ATTENTION!"
  },
  businesspage_100procentlocal_part_4: {
    nl: "Het aanleveren van het logo (.ai, .eps, .svg, .pdf-vector) maakt deel uit van het wedstrijdreglement voor deelname.",
    fr: "La fourniture du logo (.ai, .eps, .svg, .pdf vector) fait partie du règlement du concours pour la participation.",
    en: "Supplying the logo (.ai, .eps, .svg, .pdf vector) is part of the competition rules for entry."
  },
  contest_rules: {
    nl: "Lees of haal hier het wedstrijdreglement op.",
    fr: "Lire ou télécharger le règlement du concours ici.",
    en: "Read or download the competition rules here."
  },
  // 02 Personal -----------------------------------------------------------------------------------------
  start_personal_info: {
    nl: "Laten we starten met je persoonlijke gegevens",
    fr: "Commençons par vos informations personnelles",
    en: "Let's start with your personal information"
  },
  the_information_below: {
    nl: "Onderstaande gegevens worden",
    fr: "Les informations ci-dessous ne sont",
    en: "The information below is"
  },
  never: {
    nl: "NOOIT",
    fr: "JAMAIS",
    en: "NEVER"
  },
  the_information_below_part2: {
    nl: "online gepubliceerd maar ook niet gedeeld met uw lokaal bestuur.",
    fr: "publiées en ligne ni partagées avec votre gouvernement local.",
    en: "published online nor shared with your local government."
  },
  the_information_below_part3: {
    nl: "Deze zijn uitsluitend voor intern gebruik om je te contacteren wanneer er toch iets niet correct is ingevuld.",
    fr: "Ceux-ci sont à usage interne uniquement pour vous contacter si quelque chose n'est pas rempli correctement.",
    en: "These are for internal use only to contact you if something is not filled in correctly."
  },
  ci_prename: {
    nl: "Voornaam",
    fr: "Prénom",
    en: "First name"
  },
  ci_name: {
    nl: "Naam",
    fr: "Nom",
    en: "Name"
  },
  ci_mobile: {
    nl: "Mobiele telefoon",
    fr: "Téléphone mobile",
    en: "Mobile phone"
  },
  ci_phone: {
    nl: "Telefoon",
    fr: "Téléphone",
    en: "Phone"
  },
  ci_mail: {
    nl: "Email",
    fr: "E-mail",
    en: "E-mail"
  },
  ci_fax: {
    nl: "Fax",
    fr: "Télécopieur",
    en: "Fax"
  },
  // 03 Search -----------------------------------------------------------------------------------------
  how_can_visitors_reacth_you: {
    nl: "Hoe kunnen bezoekers je bereiken?",
    fr: "Les visiteurs, comment peuvent-ils vous joindre ?",
    en: "How can visitors reach you?"
  },
  you_understand_importance: {
    nl: "Je begrijpt dat het heel belangrijk is om correcte gegevens van je onderneming te publiceren.",
    fr: "Vous comprenez qu'il est très important de publier des données correctes sur votre entreprise.",
    en: "You understand that it is very important to publish correct data about your company."
  },
  visitors_reacht_you: {
    nl: "Op deze manier kunnen bezoekers je ook bereiken.",
    fr: "Ainsi, les visiteurs peuvent également vous joindre.",
    en: "This way visitors can also reach you."
  },
  the_following_information: {
    nl: "De volgende informatie zal",
    fr: "Les informations suivantes",
    en: "The following information"
  },
  visible_to_everyone: {
    nl: "ZICHTBAAR ZIJN VOOR IEDEREEN!",
    fr: "SERONT VISIBLES PAR TOUS !",
    en: "WILL BE VISIBLE TO EVERYONE!"
  },
  corporate_name: {
    nl: "Maatschappelijke Naam (kan niet gewijzigd worden)",
    fr: "Nom de l'entreprise (ne peut pas être modifié)",
    en: "Corporate name (cannot be changed)"
  },
  commercial_name: {
    nl: "Commerciële naam",
    fr: "Nom commercial",
    en: "Commercial name"
  },
  commercial_name_info: {
    nl: 'Indien uw "Commerciële naam" verschilt van uw "Officiële naam (ook Maatschappelijke naam genoemd)" kan je deze hier invoeren. Wij respecteren alle leestekens zoals je deze hier zelf invoert. Gebruik dus HOOFDLETTERS en kleine letters waar nodig!',
    fr: 'Si votre "Nom commercial" est différent de votre "Nom officiel (également appelé Raison sociale)", vous pouvez le saisir ici. Nous respectons tous les signes de ponctuation lorsque vous les saisissez ici vous-même. Utilisez donc des majuscules et des minuscules si nécessaire !',
    en: 'If your "Commercial name" is different from your "Official name (also called Corporate name)" you can enter it here. We respect all punctuation marks as you enter them here yourself. So use UPPER and lowercase where necessary!'
  },
  email_never_visible: {
    nl: "Email (wordt dus nooit zichtbaar)",
    fr: "E-mail (ne sera donc jamais visible)",
    en: "E-mail (thus never becomes visible)"
  },
  publication_of_one_telephone: {
    nl: "De publicatie van 1 telefoonnummer is een",
    fr: "La publication d'1 numéro de téléphone est une",
    en: "The publication of 1 telephone number is a"
  },
  requirement: {
    nl: "vereiste",
    fr: "exigence",
    en: "requirement"
  },
  of_FPS_economy: {
    nl: "van FOD Economie",
    fr: "du SPF Economie",
    en: "of FPS Economy"
  },
  do_you_trade_companies_or_consumers: {
    nl: "Handel je met bedrijven of consumenten?",
    fr: "Commercez-vous avec des entreprises ou des consommateurs ?",
    en: "Do you trade with companies or consumers?"
  },
  i_trade_with_b2b: {
    nl: "Ik handel met bedrijven (B2B)",
    fr: "Je commerce avec des entreprises (B2B)",
    en: "I trade with companies (B2B)"
  },
  i_trade_with_b2c: {
    nl: "Ik handel met consumenten (B2C)",
    fr: "Je commerce avec les consommateurs (B2C)",
    en: "I trade with consumers (B2C)"
  },
  i_trade_with_both: {
    nl: "Ik handel met bedrijven (B2B) en consumenten (B2C)",
    fr: "Je commerce avec les entreprises (B2B) et les consommateurs (B2C)",
    en: "I trade with companies (B2B) and consumers (B2C)"
  },
  what_do_you_offer: {
    nl: "Wat bied je aan?",
    fr: "Qu'offres-tu ?",
    en: "What do you offer?"
  },
  i_offer_both: {
    nl: "Goederen & Diensten",
    fr: "Biens et Services",
    en: "Goods and services"
  },
  i_offer_goods: {
    nl: "Goederen",
    fr: "Biens",
    en: "Goods"
  },
  i_offer_services: {
    nl: "Diensten",
    fr: "Services",
    en: "Services"
  },
  you_company_is_now_found_on: {
    nl: "Jouw onderneming wordt nu gevonden op",
    fr: "Votre entreprise sera désormais présente sur",
    en: "Your company is now found on"
  },
  all_activities: {
    nl: "alle activiteiten",
    fr: "toutes les activités",
    en: "all activities"
  },
  that_you_fill_in: {
    nl: "die je aanvult.",
    fr: "que vous réalisez.",
    en: "that you fill in"
  },
  you_company_is_now_found_on_your: {
    nl: "Jouw onderneming wordt nu gevonden op jouw",
    fr: "Votre entreprise est désormais présente sur votre",
    en: "Your company is now found on your"
  },
  main_activity: {
    nl: "hoofdactiviteit.",
    fr: "activité principale.",
    en: "main activity."
  },
  free: {
    nl: "GRATIS",
    fr: "GRATUIT",
    en: "FREE"
  },
  paying: {
    nl: "BETALEND",
    fr: "PAYANT",
    en: "PAYING"
  },
  choice_for_paying: {
    nl: "Jouw keuze voor betalend",
    fr: "Votre choix pour payer",
    en: "Your choice for paying"
  },
  commit_you_to_nothing: {
    nl: '"VERPLICHT JE TOT NIETS"!',
    fr: '"NE VOUS ENGAGEZ A RIEN" !',
    en: '"COMMITS YOU TO NOTHING"!'
  },
  the_choice_to_link_your_company: {
    nl: 'De keuze om jouw onderneming aan meerdere activiteiten te koppelen geeft uitsluitend aan dat je een vrijblijvend bezoek van onze raadgever vraagt. Tijdens dit bezoek krijg je alle informatie en kan je nog steeds terugschakelen naar de keuze voor "GRATIS" op basis van jouw hoofdactiviteit.',
    fr: 'Le choix de lier votre entreprise à plusieurs activités indique uniquement que vous demandez une visite sans engagement de notre conseiller. Au cours de cette visite, vous obtiendrez toutes les informations et vous pourrez toujours revenir au choix "GRATUIT" en fonction de votre activité principale.',
    en: 'The choice to link your company to several activities only indicates that you request a non-binding visit from our advisor. During this visit you will get all the information and you can still switch back to the choice for "FREE" based on your main activity.'
  },
  your_main_activity: {
    nl: "Jouw hoofdactiviteit:",
    fr: "Votre activité principale :",
    en: "Your main activity:"
  },
  wish_to_modify_your_activity: {
    nl: "Wens je jouw activiteit aan te passen?",
    fr: "Vous souhaitez adapter votre activité ?",
    en: "Do you wish to modify your activity?"
  },
  already_modified_your_activity: {
    nl: "Je hebt jouw activiteit al aangepast!",
    fr: "Vous avez déjà modifié votre activité !",
    en: "You have already modified your activity!"
  },
  your_activities_retrieved_from_CBE: {
    nl: "Jouw activiteiten opgehaald uit KBO:",
    fr: "Collecte de vos activités via BCE :",
    en: "Your activities retrieved from CBE:"
  },
  here_you_can_add_multiple_activities: {
    nl: "Hier kan je meerdere activiteiten toevoegen. Bij invoer van een trefwoord kan je kiezen uit de verschillende suggesties:",
    fr: "Ici, vous pouvez ajouter plusieurs activités. Lors de la saisie d'un mot clé, vous pouvez choisir parmi les différentes suggestions :",
    en: "Here you can add multiple activities. When entering a keyword you can choose from the various suggestions:"
  },
  do_you_wish_to_modify_or_add_an_activity: {
    nl: "Wens je een activiteit aan te passen of toe te voegen",
    fr: "Vous souhaitez modifier ou ajouter une activité ?",
    en: "Do you wish to modify or add an activity?"
  },
  fsma_registration: {
    nl: "FSMA registratie",
    fr: "Enregistrement FSMA",
    en: "FSMA registration"
  },
  apb_registration: {
    nl: "APB registratie",
    fr: "Enregistrement APB",
    en: "APB registration"
  },
  itaa_registration: {
    nl: "ITAA registratie",
    fr: "Enregistrement ITAA",
    en: "ITAA registration"
  },
  epc_registration: {
    nl: "EPC registratie",
    fr: "Enregistrement EPC",
    en: "EPC registration"
  },
  biv_registration: {
    nl: "BIV registratie",
    fr: "Enregistrement IPI",
    en: "BIV registration"
  },
  your_choice_for_extra_activities: {
    nl: "Jouw keuze voor extra activiteiten: (geen beperking bij betalende optie)",
    fr: "Votre choix d'activités supplémentaires : (pas de limitation avec option payante)",
    en: "Your choice for extra activities: (no limitation with paying option)"
  }
}, _defineProperty(_CustomerInfo, "here_you_can_add_multiple_activities", {
  nl: "Hier kan je meerdere activiteiten toevoegen. Bij invoer van een trefwoord kan je kiezen uit de verschillende suggesties:",
  fr: "Ici, vous pouvez ajouter plusieurs activités. Lors de la saisie d'un mot clé, vous pouvez choisir parmi les différentes suggestions :",
  en: "Here you can add multiple activities. When entering a keyword you can choose from the various suggestions:"
}), _defineProperty(_CustomerInfo, "where_can_visitors_reach_you", {
  nl: "Waar kunnen bezoekers jou bereiken?",
  fr: "Les visiteurs, où peuvent-ils vous joindre ?",
  en: "Where can visitors reach you?"
}), _defineProperty(_CustomerInfo, "important_right_location", {
  nl: "Het is belangrijk dat bezoekers jou op de juiste locatie kunnen vinden!",
  fr: "Il est important que les visiteurs puissent vous trouver au bon endroit !",
  en: "It is important that visitors can find you in the right location!"
}), _defineProperty(_CustomerInfo, "through_the_map_position_marker", {
  nl: "Via de kaart is het mogelijk om de positie van de marker (pointer) te corrigeren. De coördinaten zullen automatisch worden gecorrigeerd.",
  fr: "Via la carte, il est possible de corriger la position du marqueur (pointeur). Les coordonnées seront corrigées automatiquement.",
  en: "Through the map it is possible to correct the position of the marker (pointer). The coordinates will be corrected automatically."
}), _defineProperty(_CustomerInfo, "ci_streetname", {
  nl: "Straatnaam",
  fr: "Nom de rue",
  en: "Street"
}), _defineProperty(_CustomerInfo, "ci_house_number", {
  nl: "Huisnr",
  fr: "N° de maison",
  en: "House number"
}), _defineProperty(_CustomerInfo, "ci_box", {
  nl: "Bus",
  fr: "Box",
  en: "Box"
}), _defineProperty(_CustomerInfo, "ci_postal_code", {
  nl: "Postcode",
  fr: "Code postal",
  en: "Postal code"
}), _defineProperty(_CustomerInfo, "ci_sub_municipality", {
  nl: "Deelgemeente",
  fr: "Sous-municipalité",
  en: "Submunicipality"
}), _defineProperty(_CustomerInfo, "ci_municipality", {
  nl: "Stad of gemeente",
  fr: "Ville our municipalité",
  en: "City or municipality"
}), _defineProperty(_CustomerInfo, "ci_extra_address_info", {
  nl: "Extra adres info",
  fr: "Informations d'adresse supplémentaires",
  en: "Additional address info"
}), _defineProperty(_CustomerInfo, "ci_example_extra_address_info", {
  nl: "Voorbeeld: Ingang langs een zijstraat -",
  fr: "Exemple : Entrée le long d'une rue secondaire -",
  en: "Example: Entrance along a side street -"
}), _defineProperty(_CustomerInfo, "ci_example_extra_address_info_part2", {
  nl: "Bekijk een live voorbeeld",
  fr: "Regarder un aperçu en direct",
  en: " Watch a live preview"
}), _defineProperty(_CustomerInfo, "ci_address_info_marker", {
  nl: "Klik op het markericoontje rechtsonder de kaart en vervolgens op de correcte positie indien je dit wil wijzigen.",
  fr: "Cliquez sur l'icône du marqueur en bas à droite de la carte puis sur la bonne position si vous souhaitez la modifier.",
  en: "Click on the marker icon at the bottom right of the map and then on the correct position if you want to change this."
}), _defineProperty(_CustomerInfo, "with_you_logo_you_stand_out_more", {
  nl: "Met jouw logo val je meer op!",
  fr: "Avec votre logo vous vous démarquez davantage !",
  en: "With your logo you stand out more!"
}), _defineProperty(_CustomerInfo, "about_85_percent", {
  nl: "Ongeveer 85% van de ondernemingen heeft een logo als identificatie. Hiermee trek je ook meer de aandacht.",
  fr: "Environ 85% des entreprises ont un logo d'identification. Cela attirera également plus d'attention.",
  en: "About 85% of the companies have a logo as identification. This will also attract more attention."
}), _defineProperty(_CustomerInfo, "with_your_logo", {
  nl: "Met jouw LOGO kom je ook",
  fr: "Avec votre LOGO, vous êtes",
  en: "With your LOGO, you are"
}), _defineProperty(_CustomerInfo, "guaranteed", {
  nl: "GEGARANDEERD",
  fr: "GARANTI",
  en: "GUARANTEED"
}), _defineProperty(_CustomerInfo, "front_of_the_results", {
  nl: "vooraan in de zoekresultaten!",
  fr: "d'être en tête des résultats de recherche !",
  en: "to be at the front of the search results!"
}), _defineProperty(_CustomerInfo, "company_has_a_logo", {
  nl: "Heeft jouw onderneming of vestiging een logo?",
  fr: "Votre entreprise ou établissement a-t-elle un logo ?",
  en: "Does your company or establishment have a logo?"
}), _defineProperty(_CustomerInfo, "upload_logo_here", {
  nl: "Laad jouw logo zelf op:",
  fr: "Téléchargez votre logo ici :",
  en: "Upload your logo here:"
}), _defineProperty(_CustomerInfo, "allowed_file_formats", {
  nl: "Toegestane bestandsformaten: .ai-.svg-.cdr-.eps-.pdf (geen .jpg of .png)",
  fr: "Formats de fichiers autorisés : .ai-.svg-.cdr-.eps-.pdf (pas de .jpg ou .png)",
  en: "Allowed file formats: .ai-.svg-.cdr-.eps-.pdf (no .jpg or .png)"
}), _defineProperty(_CustomerInfo, "attention", {
  nl: "AANDACHT!",
  fr: "ATTENTION !",
  en: "ATTENTION!"
}), _defineProperty(_CustomerInfo, "logo_will_be_checked", {
  nl: "jouw logo wordt eerst nagekeken. Na validatie komt dit zichtbaar!",
  fr: "Votre logo sera vérifié en premier. Celui-ci sera visible après validation !",
  en: "Your logo will be checked first. This will be visible after validation!"
}), _defineProperty(_CustomerInfo, "logo_uploaded_by", {
  nl: "Logo opgeladen door:",
  fr: "Logo téléchargé par :",
  en: "Logo uploaded by:"
}), _defineProperty(_CustomerInfo, "our_database", {
  nl: "ONZE DATABASE",
  fr: "NOTRE BASE DE DONNÉES",
  en: "OUR DATABASE"
}), _defineProperty(_CustomerInfo, "ci_entrepreneur", {
  nl: "ONDERNEMER",
  fr: "CHEF D'ENTREPRISE",
  en: "ENTREPRENEUR"
}), _defineProperty(_CustomerInfo, "save_my_logo", {
  nl: "bewaar mijn logo",
  fr: "enregistrer mon logo",
  en: "save my logo"
}), _defineProperty(_CustomerInfo, "contact_my_printer", {
  nl: "Contacteer mijn drukker/grafisch bureau om mijn logo op te vragen:",
  fr: "Contactez mon imprimeur/agence graphique pour demander mon logo :",
  en: "Contact my printer/graphics agency to request my logo:"
}), _defineProperty(_CustomerInfo, "company_name_or_responsible_person", {
  nl: "Bedrijfsnaam of verantwoordelijke",
  fr: "Nom de l'entreprise ou personne responsable",
  en: "Company name or responsible person"
}), _defineProperty(_CustomerInfo, "you_will_automatically_receive_a", {
  nl: "Je krijgt automatisch een",
  fr: "Vous recevrez automatiquement une",
  en: "You will automatically receive a"
}), _defineProperty(_CustomerInfo, "ci_copy", {
  nl: "kopie",
  fr: "copie",
  en: "copy"
}), _defineProperty(_CustomerInfo, "of_this_email", {
  nl: "van deze mail",
  fr: "de cet e-mail",
  en: "of this e-mail"
}), _defineProperty(_CustomerInfo, "email_contact_person", {
  nl: "Email van je contactpersoon",
  fr: "E-mail de votre personne de contact",
  en: "E-mail of your contact person"
}), _defineProperty(_CustomerInfo, "this_is_the_data", {
  nl: "Dit zijn de gegevens",
  fr: "Ceci sont les données",
  en: "This is the data"
}), _defineProperty(_CustomerInfo, "but_i_am_interested", {
  nl: ". . . maar ik heb interesse!",
  fr: ". . . mais je suis intéressé !",
  en: ". . . but i'm interested!"
}), _defineProperty(_CustomerInfo, "you_want_unique_logo", {
  nl: "Jij wil een uniek en toepasselijk logo laten maken.",
  fr: "Vous souhaitez faire créer un logo unique et approprié.",
  en: "You want to have a unique and appropriate logo made."
}), _defineProperty(_CustomerInfo, "you_can_contact_us_for_this", {
  nl: "Hiervoor kan kan je bij ons terecht!",
  fr: "Vous pouvez nous contacter pour cela !",
  en: "You can contact us for this!"
}), _defineProperty(_CustomerInfo, "idb_shows_some_creations", {
  nl: "identityBuilding toont hieronder enkele van haar creaties.",
  fr: "identityBuilding montre quelques-unes de ses créations ci-dessous.",
  en: "identityBuilding shows some of her creations below."
}), _defineProperty(_CustomerInfo, "contact_me_for_proposal", {
  nl: "Contacteer mij om een voorstel te ontvangen.",
  fr: "Contactez-moi pour recevoir une proposition.",
  en: "Contact me to receive a proposal."
}), _defineProperty(_CustomerInfo, "and_i_am_not_interested", {
  nl: ". . . en ik heb geen intresse!",
  fr: ". . . et je ne suis pas intéressé !",
  en: ". . . and I'm not interested!"
}), _defineProperty(_CustomerInfo, "with_a_logo_you", {
  nl: "Met een logo trek je altijd meer bezoekers aan!",
  fr: "Avec un logo, vous attirez toujours plus de visiteurs !",
  en: "With a logo you always attract more visitors!"
}), _defineProperty(_CustomerInfo, "without_logo", {
  nl: "Zonder logo tonen wij de volgende afbeelding:",
  fr: "Sans logo, nous montrons l'image suivante :",
  en: "Without logo, we show the following image:"
}), _defineProperty(_CustomerInfo, "yes_i_am_sure", {
  nl: "JA, IK BEN ZEKER!",
  fr: "OUI, JE SUIS SÛR !",
  en: "YES I AM SURE!"
}), _defineProperty(_CustomerInfo, "add_your_internet_links", {
  nl: "Voeg jouw internet koppelingen toe",
  fr: "Ajoutez vos liens internet",
  en: "Add your internet links"
}), _defineProperty(_CustomerInfo, "show_your_visitors", {
  nl: "Toon jouw bezoekers de verschillende kanalen waar je onderneming op het internet kan gevonden worden.",
  fr: "Montrez à vos visiteurs les différents canaux où votre entreprise peut être trouvée sur Internet.",
  en: "Show your visitors the different channels where your company can be found on the internet."
}), _defineProperty(_CustomerInfo, "as_a_check", {
  nl: "Bezoek als controle je persoonlijke pagina's per kanaal en kopieer de volledige link inclusief",
  fr: "Pour vérifier, visitez vos pages personnelles par canal et copiez le lien complet, y compris",
  en: "As a check, visit your personal pages per channel and copy the full link including"
}), _defineProperty(_CustomerInfo, "http_https", {
  nl: "http of https.",
  fr: "http ou https.",
  en: "http or https."
}), _defineProperty(_CustomerInfo, "website", {
  nl: "Website",
  fr: "Site web",
  en: "Website"
}), _defineProperty(_CustomerInfo, "webshop", {
  nl: "Webshop",
  fr: "Boutique en ligne",
  en: "Webshop"
}), _defineProperty(_CustomerInfo, "contacts", {
  nl: "Contactpersonen",
  fr: "Contacts",
  en: "Contacts"
}), _defineProperty(_CustomerInfo, "because_certain_companies", {
  nl: "Omdat bepaalde ondernemingen er de voorkeur aan geven om te verwijzen naar een contactpersoon is het mogelijk om hieronder deze gegevens in te vullen.",
  fr: "Parce que certaines entreprises préfèrent se référer à une personne de contact, il est possible de renseigner ces informations ci-dessous.",
  en: "Because certain companies prefer to refer to a contact person, it is possible to fill in this information below."
}), _defineProperty(_CustomerInfo, "eg", {
  nl: "bv.",
  fr: "par exemple :",
  en: "eg:"
}), _defineProperty(_CustomerInfo, "a_department_manager", {
  nl: "een verantwoordelijke van een afdeling...",
  fr: "un responsable de département...",
  en: "a department manager..."
}), _defineProperty(_CustomerInfo, "add", {
  nl: "Toevoegen",
  fr: "Ajouter",
  en: "Add"
}), _defineProperty(_CustomerInfo, "function", {
  nl: "Functie",
  fr: "Fonction",
  en: "Function"
}), _defineProperty(_CustomerInfo, "department", {
  nl: "Afdeling",
  fr: "Département",
  en: "Department"
}), _defineProperty(_CustomerInfo, "date_of_birth", {
  nl: "Geboortedatum",
  fr: "Date de naissance",
  en: "Date of birth"
}), _defineProperty(_CustomerInfo, "avatar", {
  nl: "Afbeelding of avatar",
  fr: "Image ou avatar",
  en: "Image or avatar"
}), _defineProperty(_CustomerInfo, "spoken_languages", {
  nl: "Gesproken talen",
  fr: "Langue parlée",
  en: "Spoken languages"
}), _defineProperty(_CustomerInfo, "offers_the", {
  nl: "biedt de",
  fr: "vous propose le",
  en: "offers the"
}), _defineProperty(_CustomerInfo, "i_allow_my_customers", {
  nl: "Ik sta toe dat mijn klanten hiermee kunnen betalen.",
  fr: "Je permets à mes clients de payer avec ça.",
  en: "I allow my customers to pay with this."
}), _defineProperty(_CustomerInfo, "what_facilities", {
  nl: "Welke faciliteiten, diensten, associaties... bied je als extra aan?",
  fr: "Quels équipements complémentaires, services, associations... proposez-vous ?",
  en: "What additional facilities, services, associations... do you offer?"
}), _defineProperty(_CustomerInfo, "not_just_payment_facilities", {
  nl: "Het zijn niet alleen betaalfaciliteiten waar men in dit digitale tijdperk naar uitkijkt.",
  fr: "Ce ne sont pas seulement les facilités de paiement que les gens attendent avec impatience à l'ère numérique.",
  en: "It is not just payment facilities that people are looking forward to in this digital age."
}), _defineProperty(_CustomerInfo, "many_other_services", {
  nl: "Heel wat andere diensten die jij aanbiedt kunnen belangrijk zijn om te communiceren met potentiële klanten.",
  fr: "De nombreux autres services que vous proposez peuvent être importants pour communiquer avec des clients potentiels.",
  en: "Many other services you offer can be important for communicating with potential customers."
}), _defineProperty(_CustomerInfo, "give_them_as_much_as_paossible", {
  nl: "Geef hen zoveel mogelijk informatie!",
  fr: "Donnez-leur le maximum d'informations !",
  en: "Give them as much information as possible!"
}), _defineProperty(_CustomerInfo, "ci_search", {
  nl: "Zoeken",
  fr: "Chercher",
  en: "Search"
}), _defineProperty(_CustomerInfo, "please_enter_facility", {
  nl: "Voeg de naam in van jouw extra faciliteit",
  fr: "Veuillez entrer le nom de votre établissement supplémentaire",
  en: "Please enter the name of your additional facility"
}), _defineProperty(_CustomerInfo, "other_possibilities", {
  nl: "Andere mogelijkheden?",
  fr: "D'autres possibilités ?",
  en: "Other possibilities?"
}), _defineProperty(_CustomerInfo, "everyting_checked", {
  nl: "Alles wordt eerst gecontroleerd vooraleer het online wordt geplaatst.",
  fr: "Tout est d'abord vérifié avant d'être mis en ligne.",
  en: "Everything is first checked before it is placed online."
}), _defineProperty(_CustomerInfo, "ci_timetables", {
  nl: "Tijdschema's",
  fr: "Horaires",
  en: "Timetables"
}), _defineProperty(_CustomerInfo, "research_has_shown", {
  nl: "Uit onderzoek is gebleken dat men in meer dan 50% van de terugkerende opzoekingen op het internet naar openingsuren zoekt.",
  fr: "Des recherches ont montré que plus de 50% des recherches récurrentes sur Internet concernent les heures d'ouverture.",
  en: "Research has shown that more than 50% of the recurring searches on the internet are for opening hours."
}), _defineProperty(_CustomerInfo, "nobody_likes", {
  nl: "Niemand staat graag voor een gesloten deur! Wij hebben rekening gehouden met",
  fr: "Personne n'aime se tenir devant une porte fermée ! Nous avons pris en compte",
  en: "Nobody likes to stand in front of a closed door! We have taken into account"
}), _defineProperty(_CustomerInfo, "all_possibilities", {
  nl: "alle mogelijkheden",
  fr: "toutes les possibilités",
  en: "all possibilities"
}), _defineProperty(_CustomerInfo, "so_that_everything_is_clear", {
  nl: "zodat alles voor de bezoeker heel duidelijk is.",
  fr: "afin que tout soit très clair pour le visiteur.",
  en: "so that everything is very clear for the visitor."
}), _defineProperty(_CustomerInfo, "do_you_have_diffrent_hours", {
  nl: "Heb je afhankelijk van seizoenen verschillende uren? Ben je marktkramer en sta je dagelijks op verschillende locaties en gedurende verschillende tijdstippen? Heb je tijdens openingstijden specifieke tijdslots waarbij je speciale acties aanbiedt?",
  fr: "Avez-vous des horaires différents selon les saisons ? Êtes-vous un vendeur de marché et êtes-vous quotidiennement à différents endroits et à différentes heures ? Avez-vous des créneaux horaires spécifiques pendant les heures d'ouverture où vous proposez des promotions spéciales ?",
  en: "Do you have different hours depending on the seasons? Are you a market vendor and are you daily at different locations and during different times? Do you have specific time slots during opening hours where you offer special promotions?"
}), _defineProperty(_CustomerInfo, "this_can_aal_be_made_clear", {
  nl: "Dit kan allemaal duidelijk gemaakt worden!",
  fr: "Cela peut être clair !",
  en: "This can all be made clear!"
}), _defineProperty(_CustomerInfo, "simple_time_schedule", {
  nl: "Eenvoudig tijschema",
  fr: "Horaires simplifiés",
  en: "Simple time schedule"
}), _defineProperty(_CustomerInfo, "my_working_hours_regular", {
  nl: "Mijn werkuren zijn regelmatig en op op sommige dagen ben ik gesloten.",
  fr: "Mes horaires de travail sont réguliers et certains jours je suis fermé.",
  en: "My working hours are regular and on some days I am closed."
}), _defineProperty(_CustomerInfo, "ci_example", {
  nl: "VOORBEELD:",
  fr: "EXEMPLE :",
  en: "EXAMPLE:"
}), _defineProperty(_CustomerInfo, "monday_till_firday", {
  nl: "Maandag tot vrijdag: 08:00 - 12:30 & 13:00 - 17:00",
  fr: "Du lundi au vendredi : 08:00 - 12:30 & 13:00 - 17:00",
  en: "Monday till Friday: 08:00 - 12:30 & 13:00 - 17:00"
}), _defineProperty(_CustomerInfo, "closed_on_weekend", {
  nl: "Gesloten op zaterdag en zondag",
  fr: "Fermé le samedi et le dimanche",
  en: "Closed on Saturday and Sunday"
}), _defineProperty(_CustomerInfo, "complicated_timetable", {
  nl: "Ingewikkeld tijdschema",
  fr: "Horaire compliqué",
  en: "Complicated timetable"
}), _defineProperty(_CustomerInfo, "my_working_hours_irregular", {
  nl: "Mijn werkuren zijn onregelmatig. De meeste werkdagen hebben verschillende uren.",
  fr: "Mes horaires de travail sont irréguliers. La plupart des jours ouvrables ont des horaires différents.",
  en: "My working hours are irregular. Most working days have different hours."
}), _defineProperty(_CustomerInfo, "monday_wednesday_friday", {
  nl: "Maandag, woensdag & vrijdag: 08:00 - 12:30",
  fr: "Lundi, mercredi et vendredi : 08:00 - 12:30",
  en: "Monday, Wednesday and Friday: 08:00 - 12:30"
}), _defineProperty(_CustomerInfo, "tuesday_thrusday", {
  nl: "Dinsdag & donderdag: 08:30 - 17:00",
  fr: "Mardi jeudi: 08:30 - 17:00",
  en: "Tuesday Thursday: 08:30 - 17:00"
}), _defineProperty(_CustomerInfo, "type_of_opening_hours", {
  nl: "Type openingsuren:",
  fr: "Type d'heures d'ouverture :",
  en: "Type of opening hours:"
}), _defineProperty(_CustomerInfo, "standard_hours", {
  nl: "Standaard uren:",
  fr: "Horaires standards :",
  en: "Standard hours:"
}), _defineProperty(_CustomerInfo, "ci_monday", {
  nl: "Maandag",
  fr: "Lundi",
  en: "Monday"
}), _defineProperty(_CustomerInfo, "ci_tuesday", {
  nl: "Dinsdag",
  fr: "Mardi",
  en: "Tuesday"
}), _defineProperty(_CustomerInfo, "ci_wednesday", {
  nl: "Woensdag",
  fr: "Mercredi",
  en: "Wednesday"
}), _defineProperty(_CustomerInfo, "ci_thursday", {
  nl: "Donderdag",
  fr: "Jeudi",
  en: "Thursday"
}), _defineProperty(_CustomerInfo, "ci_friday", {
  nl: "Vrijdag",
  fr: "Vendredi",
  en: "Friday"
}), _defineProperty(_CustomerInfo, "ci_saturday", {
  nl: "Zaterdag",
  fr: "Samedi",
  en: "Saturday"
}), _defineProperty(_CustomerInfo, "ci_sunday", {
  nl: "Zondag",
  fr: "Dimanche",
  en: "Sunday"
}), _defineProperty(_CustomerInfo, "ci_closed", {
  nl: "gesloten",
  fr: "fermé",
  en: "closed"
}), _defineProperty(_CustomerInfo, "ci_divergent", {
  nl: "afwijkend",
  fr: "divergent",
  en: "divergent"
}), _defineProperty(_CustomerInfo, "want_set_period", {
  nl: "Wil je een periode instellen?",
  fr: "Voulez-vous définir une période ?",
  en: "Do you want to set a period?"
}), _defineProperty(_CustomerInfo, "example_lowhigh_season", {
  nl: "bv. hoog- of laagseizoen",
  fr: "exemple: haute ou basse saison",
  en: "eg. high- or lowseizoen"
}), _defineProperty(_CustomerInfo, "ci_exceptions", {
  nl: "Uitzonderingen",
  fr: "Exceptions",
  en: "Exceptions"
}), _defineProperty(_CustomerInfo, "ci_hollidays", {
  nl: "bv. feestdagen",
  fr: "exemple. jours fériés",
  en: "eg. hollidays"
}), _defineProperty(_CustomerInfo, "ci_set_message", {
  nl: "Wil je een message instellen?",
  fr: "Voulez-vous définir un message ?",
  en: "Do you want to set a message?"
}), _defineProperty(_CustomerInfo, "extra_info_about_timetable", {
  nl: "bv. extra info over tijdschema",
  fr: "exemple: des informations supplémentaires sur les horaires",
  en: "e.g. extra info about time schedule"
}), _defineProperty(_CustomerInfo, "enter_a_message", {
  nl: "Voer een bericht in",
  fr: "Complétez votre message. . .",
  en: "Enter a message"
}), _defineProperty(_CustomerInfo, "other_date", {
  nl: "Andere datum",
  fr: "Date différente",
  en: "Other date"
}), _defineProperty(_CustomerInfo, "select_1", {
  nl: "Selecteer 1",
  fr: "Sélectionnez 1",
  en: "Select 1"
}), _defineProperty(_CustomerInfo, "all_holidays", {
  nl: "Alle feestdagen",
  fr: "Tous les jours fériés",
  en: "All hollidays"
}), _defineProperty(_CustomerInfo, "new_year", {
  nl: "Nieuwjaar",
  fr: "Nouvel An",
  en: "New Year"
}), _defineProperty(_CustomerInfo, "pasen", {
  nl: "Pasen",
  fr: "Pâques",
  en: "Easter"
}), _defineProperty(_CustomerInfo, "easter_monday", {
  nl: "Paasmaandag",
  fr: "Lundi de Pâques",
  en: "Easter Monday"
}), _defineProperty(_CustomerInfo, "labour_day", {
  nl: "Dag van de Arbeid",
  fr: "Fête du Travail",
  en: "Labour day"
}), _defineProperty(_CustomerInfo, "ascension_day", {
  nl: "Hemelvaart",
  fr: "Jour de l'Ascension",
  en: "Ascension day"
}), _defineProperty(_CustomerInfo, "whit_monday", {
  nl: "Pinkstermaandag",
  fr: "Lundi de Pentecôte",
  en: "Whit Monday"
}), _defineProperty(_CustomerInfo, "pentecost", {
  nl: "Pinksteren",
  fr: "Pentecôte",
  en: "Pentecost"
}), _defineProperty(_CustomerInfo, "nationial_holliday", {
  nl: "Nationale feestdag",
  fr: "Fête nationale",
  en: "Nationial Holliday"
}), _defineProperty(_CustomerInfo, "assumption_of_mary", {
  nl: "O.L.V Hemelvaart",
  fr: "l'Assomption",
  en: "Assumption of Mary"
}), _defineProperty(_CustomerInfo, "all_saints_day", {
  nl: "Allerheiligen",
  fr: "Toussaint",
  en: "All saints day"
}), _defineProperty(_CustomerInfo, "armistice_day", {
  nl: "Wapenstilstand",
  fr: "Armistice",
  en: "Armistice Day"
}), _defineProperty(_CustomerInfo, "christmas", {
  nl: "Kerstdag",
  fr: "Le jour de Noël",
  en: "Christmas"
}), _defineProperty(_CustomerInfo, "tow_more_points", {
  nl: "Nog twee puntjes..",
  fr: "Deux autres points..",
  en: "Two more points.."
}), _defineProperty(_CustomerInfo, "three_more_points", {
  nl: "Nog drie puntjes...",
  fr: "Trois autres points...",
  en: "Three more points..."
}), _defineProperty(_CustomerInfo, "congratulation_completed", {
  nl: "Proficiat!... Je hebt nu alle stappen doorlopen en wij danken je hier nogmaals voor!",
  fr: "Félicitations !... Vous avez maintenant franchi toutes les étapes et nous vous en remercions encore !",
  en: "Congratulations!... You have now completed all the steps and we thank you again for this!"
}), _defineProperty(_CustomerInfo, "we_assume", {
  nl: "We gaan ervan uit dat je interesse hebt in een Business Page want deze krijg je het eerste jaar gratis (voorwaarde is wel dat je alles hebt aangevuld wat voor jouw onderneming van toepassing is).",
  fr: "Nous supposons que vous êtes intéressé par une Business Page car vous la recevrez gratuitement la première année (à condition que vous ayez rempli tout ce qui s'applique à votre entreprise).",
  en: "We assume that you are interested in a Business Page because you will receive it for free for the first year (on the condition that you have completed everything that applies to your company)."
}), _defineProperty(_CustomerInfo, "no_obbligation_to_renew", {
  nl: "Na afloop van het eerste jaar is er ook geen enkele verplichting om dit te hernieuwen.",
  fr: "Il n'y a aucune obligation de renouvellement après la première année.",
  en: "There is no obligation to renew after the first year."
}), _defineProperty(_CustomerInfo, "interested_in_bp", {
  nl: "Ik heb intresse in mijn Business Page. (eerste jaar GRATIS - zie voorwaarden)",
  fr: "Je suis intéressé par ma Page Entreprise. (première année GRATUITE - voir conditions)",
  en: "I am interested in my Business Page. (first year FREE - see conditions)"
}), _defineProperty(_CustomerInfo, "show_bp", {
  nl: "Toon mijn persoonlijke Business Page",
  fr: "Afficher ma Page d'entreprise",
  en: "Show my personal Business Page"
}), _defineProperty(_CustomerInfo, "more_info", {
  nl: "MEER INFORMATIE",
  fr: "PLUS D'INFORMATION",
  en: "MORE INFORMATION"
}), _defineProperty(_CustomerInfo, "all_online_info", {
  nl: "Al jouw informatie wordt nu online getoond",
  fr: "Toutes vos informations sont maintenant affichées en ligne",
  en: "All your information is now shown online"
}), _defineProperty(_CustomerInfo, "only_logo_address_and_phone_online_info", {
  nl: "Jouw logo met adres en telefoonnummers worden GRATIS weergegeven",
  fr: "Votre logo avec adresse et numéros de téléphone sera affiché GRATUITEMENT",
  en: "All your information is now shown online"
}), _defineProperty(_CustomerInfo, "show_bp_button", {
  nl: "TOON HOE IK WORD WEERGEGEVEN",
  fr: "MONTRER COMMENT JE SUIS AFFICHÉ",
  en: "SHOW HOW I'M DISPLAYED"
}), _defineProperty(_CustomerInfo, "have_question", {
  nl: "Ik heb een vraag! Kan een raadgever mij vrijblijvend contacteren?",
  fr: "J'ai une question! Un conseiller peut-il me contacter sans engagement ?",
  en: "I have a question! Can a counselor contact me without obligation?"
}), _defineProperty(_CustomerInfo, "post_question", {
  nl: "Plaats jouw vraag hier...",
  fr: "Postez votre question ici...",
  en: "Post your question here"
}), _defineProperty(_CustomerInfo, "our_advisor", {
  nl: "Onze raadgever zal je zo spoedig mogelijk en vrijblijvend contacteren!",
  fr: "Notre conseiller vous contactera dans les plus brefs délais et sans engagement !",
  en: "Our advisor will contact you as soon as possible and without obligation!"
}), _defineProperty(_CustomerInfo, "earlier_you_decided", {
  nl: "Eerder besloot je om deel te nemen aan onze wedstrijd, fantastisch!",
  fr: "Tout à l'heure, vous avez décidé de participer à notre concours, fantastique !",
  en: "Earlier you decided to participate in our competition, fantastic!"
}), _defineProperty(_CustomerInfo, "please_confirm", {
  nl: 'Bevestig hieronder "DEELNAME WEDSTRIJD" om de datum en de tijd te registreren dat dit volledige formulier werd ingevuld.',
  fr: "Veuillez confirmer « PARTICIPATION AU CONCOURS » ci-dessous pour enregistrer la date et l'heure à laquelle ce formulaire complet a été rempli.",
  en: 'Please confirm "CONTEST PARTICIPATION" below to record the date and time this complete form was completed.'
}), _defineProperty(_CustomerInfo, "as_stated_introduction", {
  nl: "Zoals vermeld in de introductie en het reglement wint elke 100ste onderneming die haar gegevens volledig heeft ingevuld automatsch een jaarabonnement ter waarde van € 1600.",
  fr: "Comme indiqué dans l'introduction et le règlement, chaque 100ème entreprise ayant renseigné ses coordonnées remporte automatiquement un abonnement annuel d'une valeur de 1600 €.",
  en: "As stated in the introduction and the regulations, every 100th company that has filled in its details automatically wins an annual subscription worth € 1600."
}), _defineProperty(_CustomerInfo, "by_clicking_on", {
  nl: "Door te klikken op onderstaande knop bevestig je alle gegevens m.b.t. jouw onderneming te hebben ingevuld.",
  fr: "En cliquant sur le bouton ci-dessous, vous confirmez avoir saisi toutes les informations concernant votre entreprise.",
  en: "By clicking on the button below you confirm that you have entered all information regarding your company."
}), _defineProperty(_CustomerInfo, "participation_contest", {
  nl: "Deelname wedstrijd",
  fr: "Concours de participation",
  en: "Participation contest"
}), _defineProperty(_CustomerInfo, "congrats_done", {
  nl: "Proficiat, je bent klaar en krijgt jouw Business Page 1 jaar",
  fr: "Félicitations, vous avez terminé et obtenez votre page d'entreprise 1 an",
  en: "Congratulations, you're done and get your Business Page 1 year"
}), _defineProperty(_CustomerInfo, "thank_you_very_much", {
  nl: "We willen je vanharte bedanken!",
  fr: "Nous tenons à vous remercier chaleureusement !",
  en: "We would like to thank you very much!"
}), _defineProperty(_CustomerInfo, "we_appreciate_efforts", {
  nl: "Wij waarderen je inzet en hierdoor wordt jouw onderneminglokaal zichtbaarder.",
  fr: "Nous apprécions vos efforts et cela rend votre entrepriseplus visible localement.",
  en: "We appreciate your efforts and this makes your companymore visible locally."
}), _defineProperty(_CustomerInfo, "because_the_internet", {
  nl: "Omdat het internet steeds evolueert engageren wij ons om hierin mee te groeien.",
  fr: "Parce qu'Internet évolue constamment, nous nous engageons à grandir avec lui.",
  en: "Because the internet is constantly evolving, we are committed to growing with it."
}), _defineProperty(_CustomerInfo, "we_are_not_yet_finished", {
  nl: "Wij zijn nog niet volledig klaar met het realiseren van onze eigen ideeën en staan ook open voor jouw eventuele inbreng. Daag jij ons uit?",
  fr: "Nous n'avons pas encore complètement fini de concrétiser nos propres idées et sommes également ouverts à toute contribution que vous pourriez avoir. Allez-vous nous défier ?",
  en: "We are not yet completely finished with realizing our own ideas and are also open to any input you may have. Will you challenge us?"
}), _defineProperty(_CustomerInfo, "click_next_button", {
  nl: "Klik op de volgende knop om jouw volledige publicatie te bekijken.",
  fr: "Cliquez sur le bouton suivant pour afficher votre publication complète.",
  en: "Click on the next button to view your full publication."
}), _defineProperty(_CustomerInfo, "show_bp_finish", {
  nl: "TOON MIJN BUSINESS PAGE",
  fr: "AFFICHER MA PAGE D'ENTREPRISE",
  en: "SHOW MY BUSINESS PAGE"
}), _defineProperty(_CustomerInfo, "you_have_just_reached", {
  nl: "Je hebt net de allerlaatste stap bereikt en wij gaan ervan uit dat je dit initiatief graag deelt.",
  fr: "Vous venez d'atteindre la toute dernière étape et nous supposons que vous êtes heureux de partager cette initiative.",
  en: "You have just reached the very last step and we assume that you are happy to share this initiative."
}), _defineProperty(_CustomerInfo, "will_you_also_show", {
  nl: "Toon je dit dan ook even op de sociale media van jouw keuze?",
  fr: "Allez-vous également le montrer sur les réseaux sociaux de votre choix ?",
  en: "Will you also show this on the social media of your choice?"
}), _defineProperty(_CustomerInfo, "you_can_also_send", {
  nl: "Je kan ook rechtstreeks collega ondernemers een uitnodiging sturen die ook hun gegeven kunnen optimaliseren.",
  fr: "Vous pouvez également envoyer une invitation directement à d'autres entrepreneurs qui peuvent également optimiser leurs données.",
  en: "You can also send an invitation directly to fellow entrepreneurs who can also optimize their data."
}), _defineProperty(_CustomerInfo, "they_too_will_enjoy", {
  nl: "Ook zij zullen genieten van de voordelen die jij hebt verkregen.",
  fr: "Eux aussi profiteront des avantages que vous avez obtenus.",
  en: "They too will enjoy the benefits you have obtained."
}), _defineProperty(_CustomerInfo, "add_an_email_address", {
  nl: "Voeg een email adres toe van een collega ondernemer (optioneel)",
  fr: "Ajouter une adresse e-mail d'un collègue entrepreneur (facultatif)",
  en: "Add an email address of a colleague entrepreneur (optional)"
}), _defineProperty(_CustomerInfo, "press_the_plus_sign", {
  nl: "Druk op het “+” teken na de invoer hierboven van elk geldig e-mailadres.",
  fr: 'Appuyez sur le signe "+" après avoir saisi chaque adresse e-mail valide ci-dessus.',
  en: "Press the “+” sign after entering each valid email address above."
}), _defineProperty(_CustomerInfo, "this_way_multiple_email", {
  nl: "Op deze manier kunnen meerdere e-mail adressen worden ingevoerd.",
  fr: 'Plusieurs adresses e-mail peuvent être saisies de cette manière.',
  en: "This way multiple e-mail addresses can be entered."
}), _CustomerInfo);
var _default = CustomerInfo;
exports["default"] = _default;